import { Component } from "@angular/core";

@Component({
  selector: 'app-substituto-tributario',
  templateUrl: './substituto-tributario.component.html',
  styleUrls: ['./substituto-tributario.component.scss']
})
export class SubstitutoTributarioComponent {

}